// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y5o4","toggle":"styles_toggle__2rzic","preview":"styles_preview__3GvBd"};